export default __webpack_public_path__ + "static/joint-accounts-298217842ff0900ddfd1527a4bca8c71.svg";